@use "~theme/typography";
@use "~theme/breakpoints";

.content {
  padding: 24px 24px 0;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.field {
  margin: 0 0 16px;
}

.alwaysVisible {
  display: inherit;
}

.toggle {
  margin-bottom: 16px;

  @include breakpoints.desktop {
    margin-top: 28px;
  }
}

.accommodationField {
  margin-top: 24px;
}

.emptyError {
  display: none;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin-bottom: 24px;
}
